 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddNewPlatform":"AddNewPlatform","ResetPassword":"ResetPassword","lang-ar-js":"lang-ar-js","lang-fr-js":"lang-fr-js"}[chunkId]||chunkId) + "." + {"AddNewPlatform":"1c737902","ResetPassword":"daa60e95","chunk-04c7c6d9":"96a8d941","chunk-08348be2":"6e9982ed","chunk-173ac372":"c86702e1","chunk-1aced23e":"f885b7fd","chunk-3ee2b47c":"aec6697d","chunk-e77f1954":"4cca727d","chunk-19ffec8b":"066bb627","chunk-057a0fa4":"1ece4a3f","chunk-5d833f66":"a7be27d5","chunk-86029398":"b76d0afa","chunk-b0e0ba08":"4cdcc013","chunk-c901597c":"6f18a19f","chunk-60772520":"3af5f2ba","chunk-739beacc":"b564f205","chunk-76392eac":"e6c51776","chunk-cddaf760":"7105a72b","chunk-09316e56":"a4336db8","chunk-0c208a24":"bbbc7ed7","chunk-0cd3a036":"67d09584","chunk-6fdb5d8a":"2d72544a","chunk-88730e92":"28211e69","chunk-1f658890":"f316b2b4","chunk-5d177b48":"6fd5eece","chunk-d8049c4e":"f4816470","chunk-4c159a80":"88024d98","chunk-4dd58901":"0e4e2305","chunk-4f6deebc":"2490b9bc","chunk-5cdf9a16":"c56a6a15","chunk-5f937684":"72a98c68","chunk-665770a0":"f6c16266","chunk-732e7ae2":"5367c837","chunk-0eb28a83":"d8e7e43b","chunk-50d05ae6":"4dd6368b","chunk-74ecf879":"06e0b331","chunk-81e6438e":"48bb26d2","chunk-147c0f50":"126b9306","chunk-d50367b6":"cc9307ea","chunk-0574bb3a":"47045e31","chunk-131b8e27":"e2cbb575","chunk-162e1872":"c6477eb7","chunk-6dd53b12":"c22f3e04","chunk-b64e449c":"00cde2ec","chunk-4e3c30d6":"1016e716","chunk-351ffa5a":"f229b3f5","chunk-630c91a8":"f9444bbb","chunk-fbd596f6":"e7637caf","chunk-5c19e750":"bdd29663","chunk-67b72cb9":"716da3c8","chunk-76b5b8de":"1eac33a3","chunk-13b66f3e":"d0745c7a","chunk-0798af1c":"94923f61","chunk-14f7ea66":"20f42338","chunk-15e4740f":"ce15463e","chunk-164c7626":"893295c9","chunk-07164102":"a25b76ca","chunk-526cb31d":"afb87cd0","chunk-83fb632e":"414aa733","chunk-1d83229b":"9c6f5a18","chunk-1e857436":"1f9cde9f","chunk-1ff75b9c":"fbbde2b9","chunk-22ec8fae":"489d4c56","chunk-249cfae6":"06d379e4","chunk-28f60f38":"5d22d433","chunk-3011d30a":"65a21e86","chunk-31001712":"8e07f06f","chunk-41eb90f0":"8a64fccb","chunk-470f6c2e":"a65f6deb","chunk-59d985be":"27f8d817","chunk-5a0538ee":"27cfccb0","chunk-5d3dd47e":"c7162a1a","chunk-5e6b1b7f":"67333834","chunk-6488a1af":"00367664","chunk-657f9006":"64903c4f","chunk-65c3803c":"2b24097c","chunk-65eabde3":"d379bdea","chunk-00c58462":"40f8d59b","chunk-020ee2cc":"3a763408","chunk-0967a420":"a2d39617","chunk-096a7f28":"69fc27ac","chunk-09c095d0":"58014b48","chunk-09c2608b":"beaaa44f","chunk-db7e0e86":"f5086872","chunk-0feebfce":"92bf714b","chunk-1317f7ff":"787d6993","chunk-15468e74":"352126c9","chunk-0a4396f5":"83dc263b","chunk-3f024ec1":"f5e37372","chunk-47feed04":"27f6c1f8","chunk-1af11311":"5718661f","chunk-23f8557c":"e97df34c","chunk-2a16855b":"0a76281a","chunk-2cc705bb":"24feb4db","chunk-2d0c4c35":"2e3dce07","chunk-2d0cfc48":"f333809b","chunk-2d229624":"84df5c23","chunk-2d229bb6":"c540d455","chunk-417bd08e":"83f9e270","chunk-4b77a73a":"b7fe4500","chunk-584ff47c":"32bfbc23","chunk-5d8f1146":"92e0b02b","chunk-6629aea1":"1812c61b","chunk-70dce6f7":"eec6b8d7","chunk-70f4c463":"66eceb3c","chunk-7265886b":"42258737","chunk-7f2b860a":"5c0fd03e","chunk-875d1180":"e3a0b4d4","chunk-d4ee21da":"b153fb0d","chunk-ec8890b2":"15b10141","chunk-ecb72392":"bf53cb5f","chunk-71310779":"546aa405","chunk-8741dcfa":"21a08fa8","chunk-e98f3c76":"c5230251","chunk-775c4518":"6ac1400c","chunk-7ada92d7":"aa292c7b","chunk-7b35a887":"48c4a1c6","chunk-8a9cf9fe":"ab5d6e11","chunk-921365f2":"a918ea17","chunk-953cde5a":"6fa7631c","chunk-1613100e":"1e585479","chunk-73f6c48b":"363af228","chunk-096579d6":"65ef6f24","chunk-59f7bbd5":"f1283ef2","chunk-ad88a7ca":"adfbc709","chunk-fc12ec66":"fdf77b2a","chunk-f405f72e":"3de4dc50","chunk-00daf07a":"4f422f6a","chunk-3e8da645":"32de801f","chunk-7285809e":"00115bf9","chunk-ea7b0888":"783c7acc","lang-ar-js":"998aa4d8","lang-fr-js":"be4df629"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ResetPassword":1,"chunk-04c7c6d9":1,"chunk-173ac372":1,"chunk-1aced23e":1,"chunk-3ee2b47c":1,"chunk-e77f1954":1,"chunk-19ffec8b":1,"chunk-057a0fa4":1,"chunk-5d833f66":1,"chunk-86029398":1,"chunk-b0e0ba08":1,"chunk-c901597c":1,"chunk-739beacc":1,"chunk-76392eac":1,"chunk-cddaf760":1,"chunk-09316e56":1,"chunk-0c208a24":1,"chunk-0cd3a036":1,"chunk-6fdb5d8a":1,"chunk-88730e92":1,"chunk-1f658890":1,"chunk-5d177b48":1,"chunk-d8049c4e":1,"chunk-4c159a80":1,"chunk-4dd58901":1,"chunk-4f6deebc":1,"chunk-5cdf9a16":1,"chunk-5f937684":1,"chunk-665770a0":1,"chunk-732e7ae2":1,"chunk-0eb28a83":1,"chunk-50d05ae6":1,"chunk-74ecf879":1,"chunk-81e6438e":1,"chunk-147c0f50":1,"chunk-d50367b6":1,"chunk-0574bb3a":1,"chunk-131b8e27":1,"chunk-162e1872":1,"chunk-6dd53b12":1,"chunk-b64e449c":1,"chunk-4e3c30d6":1,"chunk-351ffa5a":1,"chunk-630c91a8":1,"chunk-5c19e750":1,"chunk-67b72cb9":1,"chunk-76b5b8de":1,"chunk-13b66f3e":1,"chunk-0798af1c":1,"chunk-14f7ea66":1,"chunk-15e4740f":1,"chunk-164c7626":1,"chunk-07164102":1,"chunk-526cb31d":1,"chunk-83fb632e":1,"chunk-1d83229b":1,"chunk-1e857436":1,"chunk-1ff75b9c":1,"chunk-22ec8fae":1,"chunk-249cfae6":1,"chunk-28f60f38":1,"chunk-3011d30a":1,"chunk-31001712":1,"chunk-41eb90f0":1,"chunk-470f6c2e":1,"chunk-5d3dd47e":1,"chunk-5e6b1b7f":1,"chunk-6488a1af":1,"chunk-657f9006":1,"chunk-65c3803c":1,"chunk-65eabde3":1,"chunk-00c58462":1,"chunk-09c095d0":1,"chunk-09c2608b":1,"chunk-db7e0e86":1,"chunk-0feebfce":1,"chunk-1317f7ff":1,"chunk-15468e74":1,"chunk-3f024ec1":1,"chunk-23f8557c":1,"chunk-2a16855b":1,"chunk-2cc705bb":1,"chunk-417bd08e":1,"chunk-4b77a73a":1,"chunk-584ff47c":1,"chunk-6629aea1":1,"chunk-70dce6f7":1,"chunk-70f4c463":1,"chunk-7265886b":1,"chunk-7f2b860a":1,"chunk-875d1180":1,"chunk-d4ee21da":1,"chunk-71310779":1,"chunk-8741dcfa":1,"chunk-775c4518":1,"chunk-7ada92d7":1,"chunk-7b35a887":1,"chunk-8a9cf9fe":1,"chunk-921365f2":1,"chunk-953cde5a":1,"chunk-1613100e":1,"chunk-73f6c48b":1,"chunk-096579d6":1,"chunk-59f7bbd5":1,"chunk-ad88a7ca":1,"chunk-fc12ec66":1,"chunk-f405f72e":1,"chunk-00daf07a":1,"chunk-3e8da645":1,"chunk-7285809e":1,"chunk-ea7b0888":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddNewPlatform":"AddNewPlatform","ResetPassword":"ResetPassword","lang-ar-js":"lang-ar-js","lang-fr-js":"lang-fr-js"}[chunkId]||chunkId) + "." + {"AddNewPlatform":"31d6cfe0","ResetPassword":"e6809256","chunk-04c7c6d9":"8a456217","chunk-08348be2":"31d6cfe0","chunk-173ac372":"7c7e44ec","chunk-1aced23e":"afd05b37","chunk-3ee2b47c":"c563b9e0","chunk-e77f1954":"943ab50f","chunk-19ffec8b":"344a3d3f","chunk-057a0fa4":"c78df23a","chunk-5d833f66":"788b8037","chunk-86029398":"14b35398","chunk-b0e0ba08":"ea0a6270","chunk-c901597c":"79890eb6","chunk-60772520":"31d6cfe0","chunk-739beacc":"4516c9d9","chunk-76392eac":"4516c9d9","chunk-cddaf760":"4516c9d9","chunk-09316e56":"726b3234","chunk-0c208a24":"ff3d539c","chunk-0cd3a036":"bafc95f3","chunk-6fdb5d8a":"90ea94d1","chunk-88730e92":"0d49e602","chunk-1f658890":"048382d8","chunk-5d177b48":"048382d8","chunk-d8049c4e":"8cf06977","chunk-4c159a80":"43be4477","chunk-4dd58901":"ba50c393","chunk-4f6deebc":"bd4fb373","chunk-5cdf9a16":"3ab95d6e","chunk-5f937684":"12eb9051","chunk-665770a0":"8af72eb7","chunk-732e7ae2":"311ce595","chunk-0eb28a83":"97b968ae","chunk-50d05ae6":"dfc2abff","chunk-74ecf879":"fdd5fbc0","chunk-81e6438e":"47989df4","chunk-147c0f50":"60cdafe2","chunk-d50367b6":"78d5243d","chunk-0574bb3a":"1c2fc220","chunk-131b8e27":"1c2fc220","chunk-162e1872":"ed5f4211","chunk-6dd53b12":"0d264235","chunk-b64e449c":"9196ef73","chunk-4e3c30d6":"27c09f4a","chunk-351ffa5a":"c7fb41a6","chunk-630c91a8":"d7b8002a","chunk-fbd596f6":"31d6cfe0","chunk-5c19e750":"42495c01","chunk-67b72cb9":"6e038945","chunk-76b5b8de":"dec2fd32","chunk-13b66f3e":"ce149816","chunk-0798af1c":"90c9e7e1","chunk-14f7ea66":"e6809256","chunk-15e4740f":"7a9a52e1","chunk-164c7626":"2ec48091","chunk-07164102":"2c9d316d","chunk-526cb31d":"a51cabb6","chunk-83fb632e":"f25c3144","chunk-1d83229b":"7b25dda8","chunk-1e857436":"7c7e44ec","chunk-1ff75b9c":"37be0b97","chunk-22ec8fae":"7b25dda8","chunk-249cfae6":"9f0782a9","chunk-28f60f38":"7b25dda8","chunk-3011d30a":"7f2a0a13","chunk-31001712":"e6809256","chunk-41eb90f0":"86349bf7","chunk-470f6c2e":"e6809256","chunk-59d985be":"31d6cfe0","chunk-5a0538ee":"31d6cfe0","chunk-5d3dd47e":"ff3d539c","chunk-5e6b1b7f":"a979a27b","chunk-6488a1af":"e6809256","chunk-657f9006":"ff3d539c","chunk-65c3803c":"7f2a0a13","chunk-65eabde3":"e374a099","chunk-00c58462":"ff21e328","chunk-020ee2cc":"31d6cfe0","chunk-0967a420":"31d6cfe0","chunk-096a7f28":"31d6cfe0","chunk-09c095d0":"4ed228ac","chunk-09c2608b":"458114b1","chunk-db7e0e86":"6a19e9cc","chunk-0feebfce":"7c7e44ec","chunk-1317f7ff":"9cc25f3d","chunk-15468e74":"726b3234","chunk-0a4396f5":"31d6cfe0","chunk-3f024ec1":"3ceb3f14","chunk-47feed04":"31d6cfe0","chunk-1af11311":"31d6cfe0","chunk-23f8557c":"f36f23bc","chunk-2a16855b":"2084efea","chunk-2cc705bb":"8abd55b7","chunk-2d0c4c35":"31d6cfe0","chunk-2d0cfc48":"31d6cfe0","chunk-2d229624":"31d6cfe0","chunk-2d229bb6":"31d6cfe0","chunk-417bd08e":"eacf8de4","chunk-4b77a73a":"0ed1b1a4","chunk-584ff47c":"726b3234","chunk-5d8f1146":"31d6cfe0","chunk-6629aea1":"45639a41","chunk-70dce6f7":"7c7e44ec","chunk-70f4c463":"7c7e44ec","chunk-7265886b":"f62f5ee1","chunk-7f2b860a":"46c25e14","chunk-875d1180":"17ecf23d","chunk-d4ee21da":"b82c969a","chunk-ec8890b2":"31d6cfe0","chunk-ecb72392":"31d6cfe0","chunk-71310779":"3639aeaf","chunk-8741dcfa":"a4b8b023","chunk-e98f3c76":"31d6cfe0","chunk-775c4518":"c637a89c","chunk-7ada92d7":"ab87714c","chunk-7b35a887":"ff3d539c","chunk-8a9cf9fe":"7b25dda8","chunk-921365f2":"7f2a0a13","chunk-953cde5a":"e6809256","chunk-1613100e":"a0a84a88","chunk-73f6c48b":"163a1e7f","chunk-096579d6":"622b067b","chunk-59f7bbd5":"622b067b","chunk-ad88a7ca":"e205aa54","chunk-fc12ec66":"87615114","chunk-f405f72e":"ff3d539c","chunk-00daf07a":"5609e321","chunk-3e8da645":"1fc767c6","chunk-7285809e":"4e8b1b9f","chunk-ea7b0888":"8e375347","lang-ar-js":"31d6cfe0","lang-fr-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
